 class Admin {
     constructor(data) {
         this.id = data.id;
         this.name = data.name;
         this.number = data.number.replace("+98", "0");
         this.lastEntry = data.lastEntry;
         this.access = data.access;
         this.status = data.status;
         this.pin = data.pin;
     }

     getId() {
         return this.id;
     }
 }
 class AdminLog {
    date;
    text;
    constructor(a,b){
        this.date=a;
        this.text=b
    }
}
export {Admin};
export {AdminLog};